import { storeQualityToCustomer } from "api/Customers";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useStoreQuality = () => {
    const queryClient = useQueryClient();

    return useMutation(storeQualityToCustomer, {
        onSuccess: () => {
            toast.success("Created Successfully");
            queryClient.invalidateQueries('quality-check-customers')

        },
        onError: () => {
            toast.error("Failed to store document");
        },
    });
};
